import { useState } from "react";
import { useTranslation } from "react-i18next";
import { testimonials } from "@/mocks/data";

export default function Testimonials() {
  const { t, i18n } = useTranslation();
  const [index, setIndex] = useState(0);
  const isJa = i18n.language === "ja";

  const current = testimonials[index];

  const prev = () => setIndex((i) => (i === 0 ? testimonials.length - 1 : i - 1));
  const next = () => setIndex((i) => (i === testimonials.length - 1 ? 0 : i + 1));

  return (
    <section className="relative bg-midnight py-24 md:py-36 overflow-hidden">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-warmgray text-xs font-sans tracking-widest uppercase block mb-6">
            ({t("testimonials.label")})
          </span>

          <h2 className="text-marble font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-wide mb-16 md:mb-24">
            {t("testimonials.title")}
          </h2>

          <blockquote className="relative">
            <i className="ri-double-quotes-l text-champagne/40 text-3xl absolute -top-4 left-0 md:-left-4" />
            <p className="text-marble/80 text-lg md:text-xl font-serif leading-relaxed pl-8 md:pl-10 text-left">
              {isJa ? current.quote : current.quoteEn}
            </p>
          </blockquote>

          <div className="mt-8 flex items-center justify-center gap-3">
            <span className="w-6 h-px bg-champagne" />
            <div>
              <p className="text-marble font-sans text-sm font-medium">
                {current.author}
              </p>
              <p className="text-warmgray text-xs font-sans">
                {isJa ? current.role : current.roleEn}
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-12">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-warmgray/30 flex items-center justify-center text-warmgray hover:border-marble hover:text-marble transition-all duration-300"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full bg-marble/10 flex items-center justify-center text-marble hover:bg-marble/20 transition-all duration-300"
            >
              <i className="ri-arrow-right-line" />
            </button>
            <span className="text-warmgray/50 text-xs font-sans ml-2">
              {String(index + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}